import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Remove the splash screen once the app has mounted
requestAnimationFrame(() => {
  setTimeout(() => {
    const s = document.getElementById("vs-splash");
    if (s) { s.style.opacity = "0"; setTimeout(() => s.remove(), 450); }
  }, 350);
});
